import dayjs from 'dayjs';

import { ActionType } from '../../actionTypes';
import { createApiRequestAction } from '../../helpers';
import { availability as availabilitySchema } from '../../schema';
import { Service } from '../../types';

const MAX_TIME_WINDOW_IN_DAYS = 90;

export const fetchExperimentAvailability = (
  domain: string,
  restrictBy: string,
  experimentName: string,
  version: number,
  isOverlap: boolean,
  isExpTimeSliceOrGroupStrategy: boolean,
) => {
  const now = dayjs();
  const start = now.format('YYYY-MM-DD');
  const end = now.add(MAX_TIME_WINDOW_IN_DAYS, 'days').format('YYYY-MM-DD');
  const offsetInSec = now.utcOffset() * 60;
  experimentName = experimentName ? experimentName : '';
  version = version ? version : 1;
  const queryParams = {
    start,
    end,
    offsetInSec,
    includePartialFlag: true,
    experimentName,
    version,
    isOverlap,
    isExpTimeSliceOrGroupStrategy,
  };

  return createApiRequestAction(
    ActionType.FETCH_EXPERIMENT_AVAILABILITY_REQUESTED,
    {
      domain,
      restrictBy,
      request: {
        method: 'GET',
        service: Service.PLANNER,
        url: `/v1/experiments/availability/${domain}/${restrictBy}/`,
        queryParams,
        normalizr: {
          schema: availabilitySchema,
        },
        responseTypes: {
          started: ActionType.FETCH_EXPERIMENT_AVAILABILITY_STARTED,
          succeeded: ActionType.FETCH_EXPERIMENT_AVAILABILITY_SUCCEEDED,
          failed: ActionType.FETCH_EXPERIMENT_AVAILABILITY_FAILED,
        },
      },
    },
  );
};
